/* Secret Scenta, product page behaviour.
   Without JS the form still posts to /cart/add and the first frame shows. */
(() => {
  'use strict';

  const root = document.querySelector('[data-pdp]');
  if (!root) return;

  const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const blockedVariantNode = root.querySelector('[data-france-blocked-variants]');
  let blockedVariantIds = new Set();
  try { blockedVariantIds = new Set(JSON.parse(blockedVariantNode?.textContent || '[]').map(String)); } catch (e) {}
  const isVariantAvailable = (variant) => Boolean(variant && variant.available) && !blockedVariantIds.has(String(variant.id));
  const form = root.querySelector('form[action*="/cart/add"]');
  const idInput = root.querySelector('[data-variant-id]');
  const atc = root.querySelector('[data-atc]');
  const atcLabel = root.querySelector('[data-atc-label]');
  const addedNote = root.querySelector('[data-added-note]');
  const unavailableNote = root.querySelector('[data-unavailable-note]');
  const priceEl = root.querySelector('.pdp__price-value');
  const sticky = root.querySelector('[data-sticky-atc]');
  const stickyVariant = root.querySelector('[data-sticky-variant]');
  const stickyPrice = root.querySelector('.pdp-sticky__price');
  const stickyAdd = root.querySelector('[data-sticky-add]');
  const stickyLabel = root.querySelector('[data-sticky-label]');
  const selectionTitle = root.querySelector('[data-selection-title]');
  const selectionTotal = root.querySelector('[data-selection-total]');
  const selectionDetail = root.querySelector('[data-selection-detail]');
  const strings = {
    add: atcLabel ? atcLabel.textContent.trim() : 'Ajouter au panier',
    // from the locale via the button, never hardcoded, the store is French-first
    soldOut: (atc && atc.dataset.soldOutLabel) || 'Victime de son succès',
  };

  const currency = document.documentElement.lang && Intl
    ? new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: root.dataset.currency || 'EUR',
      })
    : null;
  const money = (cents) => (currency ? currency.format(cents / 100) : (cents / 100).toFixed(2));
  let activeVariant = product.variants.find((variant) => String(variant.id) === String(idInput?.value)) || product.variants[0];

  /* Price with an optional struck-through original, mirrors snippets/price.liquid.
     Must REBUILD the child nodes rather than set textContent: the server renders
     <span class="money-now"> + <s class="money-was">, and blanking it with
     textContent drops the compare-at price on the very first variant swap. */
  function renderPrice(el, variant) {
    if (!el) return;
    const compare = variant.compare_at_price;
    if (compare && compare > variant.price) {
      const now = document.createElement('span');
      now.className = 'money-now';
      now.textContent = money(variant.price);
      const was = document.createElement('s');
      was.className = 'money-was';
      was.textContent = money(compare);
      el.replaceChildren(now, ' ', was);
      el.classList.add('is-sale');
    } else {
      el.replaceChildren(money(variant.price));
      el.classList.remove('is-sale');
    }
  }

  /* ---------- gallery ---------- */
  const gallery = root.querySelector('[data-gallery]');
  const frames = [...root.querySelectorAll('[data-frame]')];
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hydrateFrame(index) {
    const img = frames[index]?.querySelector('[data-pdp-deferred-src]');
    if (!img) return;
    const src = img.dataset.pdpDeferredSrc;
    if (!src) return;
    img.src = src;
    img.removeAttribute('data-pdp-deferred-src');
  }

  if (gallery && 'IntersectionObserver' in window) {
    const frameObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = frames.indexOf(entry.target);
        if (index >= 0) hydrateFrame(index);
        observer.unobserve(entry.target);
      });
    }, { root: gallery, rootMargin: '0px 40%', threshold: 0.01 });
    frames.slice(1).forEach((frame) => frameObserver.observe(frame));
  }

  function showFrame(index) {
    hydrateFrame(index);
    frames.forEach((f, i) => f.classList.toggle('is-active', i === index));
    // thumbs carry their frame index in data-thumb, the strip may hide some
    // frames (per-finish variant images), so array position can't be trusted
    thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.thumb) === index));
    // On mobile the gallery is a swipe carousel: every frame is always rendered
    // and .is-active has no visual effect, so bring the chosen frame into view
    // by scrolling the strip itself (no page scroll, we move gallery.scrollLeft).
    const target = frames[index];
    if (target && gallery && gallery.scrollWidth > gallery.clientWidth + 1) {
      const delta = target.getBoundingClientRect().left - gallery.getBoundingClientRect().left
        - (gallery.clientWidth - target.clientWidth) / 2;
      gallery.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }
  thumbs.forEach((t) => t.addEventListener('click', () => showFrame(Number(t.dataset.thumb))));

  /* ---------- per-finish gallery re-dress ----------
     finish_swap: { "<finish value>": { "<frame index>": "<img url>", … } }
     The listed frames (packshot, macro) change to the chosen finish; every
     other frame restores to its original. Lifestyle frames never swap. */
  const finishSwapEl = root.querySelector('[data-finish-swap]');
  const finishSwap = finishSwapEl ? JSON.parse(finishSwapEl.textContent || 'null') : null;
  const frameImgs = frames.map((f) => f.querySelector('img'));
  const frameOriginals = frameImgs.map((img) =>
    img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') } : null
  );
  const thumbImgsByFrame = {};
  thumbs.forEach((t) => {
    const img = t.querySelector('img');
    if (img) thumbImgsByFrame[Number(t.dataset.thumb)] = { img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
  });
  function setImg(img, url, orig) {
    if (!img || !orig) return;
    if (url) {
      img.setAttribute('src', url);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    } else {
      if (orig.src) img.setAttribute('src', orig.src); else img.removeAttribute('src');
      if (orig.srcset) img.setAttribute('srcset', orig.srcset); else img.removeAttribute('srcset');
      if (orig.sizes) img.setAttribute('sizes', orig.sizes); else img.removeAttribute('sizes');
    }
  }
  function applyFinishSwap(variant) {
    if (!finishSwap || !variant) return false;
    const map = finishSwap[variant.option1] || finishSwap[variant.title] || null;
    frames.forEach((f, i) => {
      const url = map ? map[i] : null;
      setImg(frameImgs[i], url, frameOriginals[i]);
      const t = thumbImgsByFrame[i];
      if (t) setImg(t.img, url, t);
    });
    if (map) showFrame(0);
    return Boolean(map);
  }

  /* ---------- variant selection ---------- */
  function selectedOptions() {
    return [...root.querySelectorAll('.pdp__options')].map(
      (fs) => fs.querySelector('input:checked')?.value
    );
  }

  function findVariant(options) {
    return product.variants.find((v) =>
      options.every((value, i) => !value || v.options[i] === value)
    );
  }

  function updateBuyState(variant) {
    const available = isVariantAvailable(variant);
    if (atc) atc.disabled = !available;
    if (stickyAdd) stickyAdd.disabled = !available;
    const label = available ? strings.add : strings.soldOut;
    if (atcLabel) atcLabel.textContent = label;
    if (stickyLabel) stickyLabel.textContent = label;
    if (unavailableNote) unavailableNote.hidden = available;
  }

  function onVariantChange() {
    const variant = findVariant(selectedOptions());
    if (!variant) {
      updateBuyState(null);
      return;
    }
    idInput.value = variant.id;
    activeVariant = variant;
    renderPrice(priceEl, variant);
    if (stickyVariant) stickyVariant.textContent = variant.title;
    renderPrice(stickyPrice, variant);
    updateBuyState(variant);
    refreshOffer();

    // re-dress the gallery in the chosen finish; otherwise fall back to
    // jumping to the variant's own image if it has one
    const swapped = applyFinishSwap(variant);
    if (!swapped && variant.featured_media) {
      // Prefer an existing gallery frame. If the selected variant was rendered
      // server-side into frame 0, another finish may no longer have its own frame;
      // in that case replace frame 0 directly instead of downloading a second
      // above-the-fold image during initial load.
      const index = frames.findIndex((f) => Number(f.dataset.mediaId) === variant.featured_media.id);
      if (index >= 0) {
        showFrame(index);
      } else {
        const preview = variant.featured_media.preview_image?.src;
        if (preview && frameImgs[0]) {
          const joiner = preview.includes('?') ? '&' : '?';
          setImg(frameImgs[0], preview + joiner + 'width=1080', frameOriginals[0]);
          frames[0].dataset.mediaId = variant.featured_media.id;
          showFrame(0);
        }
      }
    }

    // active pill / swatch styling
    root.querySelectorAll('.pdp__option, .pdp__swatch').forEach((label) => {
      const input = label.querySelector('input');
      label.classList.toggle('is-active', input.checked);
    });
    // reflect the picked value beside the option name (finish swatches)
    root.querySelectorAll('[data-option-selected]').forEach((el) => {
      const fs = el.closest('.pdp__options');
      const checked = fs && fs.querySelector('input:checked');
      if (checked) el.textContent = checked.value;
    });

    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('[data-option-value]').forEach((input) => {
    const fieldset = input.closest('.pdp__options');
    const optionIndex = Number(fieldset?.dataset.optionIndex || 0);
    const usable = product.variants.some((variant) =>
      String(variant.options?.[optionIndex]) === input.value && isVariantAvailable(variant)
    );
    if (!usable) {
      input.disabled = true;
      const label = input.closest('.pdp__option, .pdp__swatch');
      label?.classList.add('is-unavailable');
      if (label) label.title = 'Victime de son succès';
    }
    input.addEventListener('change', onVariantChange);
  });

  /* ---------- fragrance upsell (the 'fragrance_upsell' block) ----------
     MULTI-SELECT: a shopper may pick several fragrances; each adds one line.
     Cards are buttons with data-* only, nothing named, so they never enter the
     form's FormData. addToCart() posts the diffuser plus every chosen scent. */
/* Diffuser page: the appliance stays a one-time purchase; only the selected
   fragrance can receive a selling plan. This block runs inside product.js. */
  const upsell = root.querySelector('[data-pdp-upsell]');
  const upsellNote = root.querySelector('[data-upsell-note]');
  const pickedScents = () => (upsell ? [...upsell.querySelectorAll('[data-scent-pick].is-selected')] : []);
  const savingCents = (Number(upsell?.dataset.coffretSaving) || 20) * 100;
  const scentSubscriptionPrice = 4410;
  let scentPurchaseMode = 'one-time';
  let scentPlanSelect = null;

  function refreshOffer() {
    if (!activeVariant) return;
    const qty = Math.max(1, parseInt(root.querySelector('.qty__input')?.value || '1', 10));
    const scents = pickedScents();
    const isSubscription = scentPurchaseMode === 'subscription';
    const regularScentTotal = scents.reduce((sum, scent) => sum + Number(scent.dataset.price || 0), 0);
    const scentTotal = isSubscription ? scents.length * scentSubscriptionPrice : regularScentTotal;
    const discount = scents.length && !isSubscription ? savingCents : 0;
    const total = activeVariant.price * qty + scentTotal - discount;
    const title = scents.length ? `${product.title} + ${scents[0].dataset.title}` : `${product.title} seul`;
    if (selectionTitle) selectionTitle.textContent = title;
    if (selectionTotal) selectionTotal.textContent = money(total);
    if (selectionDetail) {
      selectionDetail.textContent = scents.length
        ? (isSubscription
          ? `Diffuseur acheté une fois. ${scents[0].dataset.title} sera livré selon la fréquence choisie.`
          : `Remise de ${money(discount)} appliquée au parfum sélectionné.`)
        : `Choisissez un parfum 100 ml, puis sélectionnez l’achat ponctuel ou l’abonnement.`;
    }
    if (atcLabel && !atc?.disabled) atcLabel.textContent = scents.length ? `Ajouter l’ensemble • ${money(total)}` : `Ajouter au panier • ${money(total)}`;
    if (stickyLabel && !stickyAdd?.disabled) stickyLabel.textContent = scents.length ? 'Ajouter l’ensemble' : strings.add;
    if (stickyPrice && !scents.length && qty === 1) renderPrice(stickyPrice, activeVariant);
    else if (stickyPrice) stickyPrice.textContent = money(total);
    if (stickyVariant) stickyVariant.textContent = scents.length ? scents[0].dataset.title : activeVariant.title;
  }

  if (upsell) {
    const intro = upsell.closest('.pdp-auto-upsell-wrap')?.querySelector('.pdp-auto-upsell-wrap__intro');
    if (intro) intro.textContent = 'Choisissez votre parfum 100 ml. Vous pourrez ensuite l’acheter une fois ou le recevoir automatiquement.';

    const planBox = document.createElement('section');
    planBox.className = 'diffuser-scent-plan';
    planBox.hidden = true;
    planBox.setAttribute('aria-label', 'Formule du parfum sélectionné');
    planBox.innerHTML = `
      <p class="diffuser-scent-plan__eyebrow">VOTRE PARFUM</p>
      <div class="diffuser-scent-plan__options">
        <label class="diffuser-scent-plan__option is-selected">
          <input type="radio" name="diffuser_scent_purchase" value="one-time" checked>
          <span class="diffuser-scent-plan__radio" aria-hidden="true"></span>
          <span class="diffuser-scent-plan__copy"><strong>Achat ponctuel</strong><small>Ajouté une seule fois</small></span>
          <strong class="diffuser-scent-plan__price">49,00 €</strong>
        </label>
        <label class="diffuser-scent-plan__option">
          <input type="radio" name="diffuser_scent_purchase" value="subscription">
          <span class="diffuser-scent-plan__radio" aria-hidden="true"></span>
          <span class="diffuser-scent-plan__copy"><span class="diffuser-scent-plan__title"><strong>S’abonner au parfum</strong><em>−10 %</em></span><small>44,10 € par livraison</small></span>
          <strong class="diffuser-scent-plan__price">44,10 €</strong>
        </label>
      </div>
      <div class="diffuser-scent-plan__frequency" hidden>
        <label for="diffuser-scent-frequency">Fréquence de livraison</label>
        <select id="diffuser-scent-frequency" aria-label="Fréquence de livraison du parfum">
          <option value="15342469318">Tous les mois</option>
          <option value="15342502086">Tous les 2 mois</option>
          <option value="15342534854">Tous les 3 mois</option>
        </select>
        <p>Le diffuseur est payé une seule fois. Modifiez, suspendez ou annulez le parfum à tout moment.</p>
      </div>`;
    upsell.insertAdjacentElement('afterend', planBox);
    scentPlanSelect = planBox.querySelector('select');

    const style = document.createElement('style');
    style.textContent = `
      .diffuser-scent-plan{margin-top:16px;padding:16px;border:1px solid var(--color-line,#d8d4cc);border-radius:12px;background:var(--color-surface,#fff)}
      .diffuser-scent-plan[hidden]{display:none!important}.diffuser-scent-plan__eyebrow{margin:0 0 10px;font-size:11px;font-weight:700;letter-spacing:.16em;color:var(--color-green,#315c4b)}
      .diffuser-scent-plan__options{display:grid;gap:8px}.diffuser-scent-plan__option{display:grid;grid-template-columns:18px minmax(0,1fr) auto;gap:10px;align-items:center;padding:13px;border:1px solid var(--color-line,#ddd8cf);border-radius:10px;cursor:pointer}
      .diffuser-scent-plan__option.is-selected{border-color:var(--color-ink,#171714);background:#faf8f3}.diffuser-scent-plan__option input{position:absolute;opacity:0;pointer-events:none}
      .diffuser-scent-plan__radio{width:16px;height:16px;border:1px solid #b9b4aa;border-radius:50%;box-shadow:inset 0 0 0 4px #fff}.diffuser-scent-plan__option.is-selected .diffuser-scent-plan__radio{background:var(--color-ink,#171714);border-color:var(--color-ink,#171714)}
      .diffuser-scent-plan__copy{display:grid;gap:2px;min-width:0}.diffuser-scent-plan__copy strong{font-size:14px;line-height:1.25}.diffuser-scent-plan__copy small{font-family:var(--font-serif,'Cormorant Garamond',serif);font-size:13px;font-style:italic;color:var(--color-muted,#81786d)}
      .diffuser-scent-plan__title{display:flex;align-items:center;gap:7px;flex-wrap:wrap}.diffuser-scent-plan__title em{padding:3px 7px;border-radius:999px;background:var(--color-ink,#171714);color:#fff;font:700 10px/1 var(--font-sans,Arial,sans-serif);letter-spacing:.06em}
      .diffuser-scent-plan__price{white-space:nowrap;font-size:14px}.diffuser-scent-plan__frequency{margin-top:10px;padding:12px 13px;background:#f7f4ee;border-radius:10px}.diffuser-scent-plan__frequency[hidden]{display:none!important}
      .diffuser-scent-plan__frequency label{display:block;margin-bottom:6px;font-size:12px;font-weight:700}.diffuser-scent-plan__frequency select{width:100%;min-height:42px;padding:0 34px 0 12px;border:1px solid var(--color-line,#d8d4cc);border-radius:8px;background:#fff;color:inherit;font:inherit}
      .diffuser-scent-plan__frequency p{margin:8px 0 0;font:italic 13px/1.35 var(--font-serif,'Cormorant Garamond',serif);color:var(--color-muted,#81786d)}
      @media(max-width:389px){.diffuser-scent-plan{padding:13px}.diffuser-scent-plan__option{grid-template-columns:16px minmax(0,1fr) auto;padding:11px 10px;gap:8px}.diffuser-scent-plan__copy strong,.diffuser-scent-plan__price{font-size:13px}}
    `;
    document.head.appendChild(style);

    const syncPlanBox = () => {
      const scents = pickedScents();
      planBox.hidden = scents.length === 0;
      const chosen = planBox.querySelector('input:checked')?.value || 'one-time';
      scentPurchaseMode = chosen;
      planBox.querySelectorAll('.diffuser-scent-plan__option').forEach((option) => {
        option.classList.toggle('is-selected', option.querySelector('input').checked);
      });
      planBox.querySelector('.diffuser-scent-plan__frequency').hidden = chosen !== 'subscription';
      refreshOffer();
    };
    planBox.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', syncPlanBox));
    scentPlanSelect.addEventListener('change', refreshOffer);

    const picks = [...upsell.querySelectorAll('[data-scent-pick]')];
    picks.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.hasAttribute('disabled')) return;
        const shouldSelect = !button.classList.contains('is-selected');
        picks.forEach((other) => {
          const selected = other === button && shouldSelect;
          other.classList.toggle('is-selected', selected);
          other.setAttribute('aria-pressed', String(selected));
        });
        syncPlanBox();
      });
    });
  }
  /* ---------- quantity ---------- */
  const qtyInput = root.querySelector('.qty__input');
  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    refreshOffer();
  });
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    refreshOffer();
  });
  qtyInput?.addEventListener('change', refreshOffer);
  refreshOffer();

  /* ---------- add to cart (AJAX; falls back to normal POST without JS) ---------- */
  let adding = false;
  async function addToCart() {
    if (adding || !form) return;
    if (!isVariantAvailable(activeVariant)) {
      updateBuyState(activeVariant);
      if (unavailableNote) unavailableNote.hidden = false;
      root.querySelector('[data-market-stock]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    adding = true;
    const root_url = window.Shopify?.routes?.root || '/';
    try {
      const picked = pickedScents();
      let response;
      if (picked.length) {
        // diffuser + chosen scent in ONE atomic add, /cart/add.js only accepts
        // multiple line items via the JSON {items:[…]} body, not FormData.
        const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
        response = await fetch(`${root_url}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(idInput.value), quantity: qty },
              ...picked.map((p) => ({
                id: Number(p.dataset.scentId),
                quantity: 1,
                ...(scentPurchaseMode === 'subscription' && scentPlanSelect
                  ? { selling_plan: Number(scentPlanSelect.value) }
                  : {}),
              })),
            ],
          }),
        });
      } else {
        response = await fetch(`${root_url}cart/add.js`, {
          method: 'POST',
          body: new FormData(form),
        });
      }
      if (!response.ok) throw new Error('add failed');
      const cartRes = await fetch(`${root_url}cart.js`);
      const cart = await cartRes.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      if (addedNote) {
        addedNote.hidden = false;
      }
    } catch {
      form.submit(); // graceful fallback to the full-page flow
    } finally {
      adding = false;
    }
  }

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    addToCart();
  });
  stickyAdd?.addEventListener('click', addToCart);

  /* ---------- sticky bar visibility ---------- */
  const buyBox = root.querySelector('[data-buy-box]');
  if (buyBox && sticky && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      },
      { threshold: 0 }
    );
    io.observe(buyBox);
  }
})();

